<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="agency-xls-upload">
				<h1>입고엑셀등록</h1>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
					<el-form-item label="엑셀파일: " prop="excle_url">
						<el-upload
						  
						  :action="update_url+'/common/upload'"
						  :on-preview="handlePreview"
						  :on-remove="handleRemove"
						
						  :before-upload="beforeUpload"
						  :limit="1"
						  :on-success="handleSuccess"
						  :file-list="fileList">
						 <!-- <img width="100%" :src="ruleForm.fileList[0].url" alt=""> -->
						
						  <el-button size="small" type="primary">파일선택</el-button>
						  <div slot="tip" class="el-upload__tip">Excel 파일만 업로드할 수 있으며, 1 MB를 초과할 수 없습니다.</div>
						</el-upload>
					</el-form-item>
					<el-form-item>
					    <el-button type="primary" @click="submitForm('ruleForm')">업로드</el-button>
					   
					</el-form-item>
				
				</el-form>
				<div class="row" >
					<el-row>
						<el-col :xs="24" :sm="4">
							<div style="display: flex;justify-content: center;font-weight: bold; ">
								샘플양식
							</div>
						</el-col>
						<el-col :xs="24" :sm="20">
							<div>
								<el-button round @click="openExcel">다운로드</el-button>
							</div>
						</el-col>
					</el-row>
				
				</div>
				
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	import Constants from '@/constants'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return {
				ruleForm: {
					excle_url:'',
				},
				rules: {
					excle_url:[
						{ required: true, message: 'Excel 파일 필수', trigger: 'change' }
					]
				
				},
				fileList: [],
				update_url:'',
				server_url:'',
				
			}
			
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			}
		},
		created() {
			console.log(Constants.BASE_URL) 
			console.log(Constants.SERVER_URL) 
			this.update_url = Constants.BASE_URL
			this.server_url = Constants.SERVER_URL
		},
		methods: {
			openExcel(){
				window.open(this.server_url+"/assets/excel/warehouse_upload_sample_ko.xls", '_blank')
			},
			submitForm(formName) {
				this.$confirm('제출하시겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					
					this.$refs[formName].validate((valid) => {
					  if (valid) {
						console.log(this.ruleForm,"提交表单")
						request.post('/member/Inventory/registerWarehouseExcel',
							this.ruleForm
						).then(response => {
							console.log(response,"提交?????")			  
							if(response.code ==1){
								alert(response.msg);
								//console.log('审核！');
								if (this.$route.query.type === 'coupang' || this.$route.query.activeMenu) {
									this.$router.replace({ query: { ...this.$route.query, type: 'coupang', activeMenu: 'coupang_inventory_warehouse' } }).catch(() => {});
								} else {
									this.$router.replace('/inventoryWarehouse').catch(() => {});
								}
						
							}else{
								alert(response.msg)
								return
							}
								
						});
						      
			
						
					  } else {
						console.log('error submit!!');
						return false;
					  }
					});
				  
				  
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '已取消删除'
				  });          
				});
				
				
				
			},
			isExcel(file) {
			  const suffix = file.name.split('.').pop().toLowerCase();
			  const mimeTypes = [
			    'application/vnd.ms-excel',
			    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			    'application/vnd.ms-excel.sheet.macroEnabled.12',
			    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
			    'text/csv'
			  ];
			  const suffixes = ['xls', 'xlsx', 'xlsm', 'xlsb', 'csv'];
			  return mimeTypes.includes(file.type) || suffixes.includes(suffix);
			},
			//上传文件之前的钩子
			beforeUpload(file){
				console.log(file,"上传文件之前的钩子")
				const isLt1M = file.size / 1024 / 1024 < 1;
				let isExcel = this.isExcel(file)
				if (!isExcel) {
					this.$message.error('Excel 파일 형식만 업로드할 수 있습니다!');
					return false
				}
				if (!isLt1M) {
					this.$message.error('이미지 업로드 크기는 1MB를 초과할 수 없습니다!');
					return false
				}
			
			},
			//文件上传成功时的钩子
			handleSuccess(res, file,fileList) {
				console.log(res,11)
				console.log(file,22)
				console.log(fileList,33)
				if(res.code ==1){
					this.fileList=[{name: file.name, url: res.data.fullurl}]
					this.ruleForm.excle_url=res.data.url
					
				}
					
				
			},
			//文件列表移除文件时的钩子
			handleRemove(file, fileList) {
				console.log(file, fileList,"文件列表移除文件时的钩子");
				this.fileList=[]
				this.ruleForm.excle_url=''
			},
			//点击文件列表中已上传的文件时的钩子
			handlePreview(file) {
				console.log(file,"点击文件列表中已上传的文件时的钩子");
				window.open(file.url, '_blank')
			},
		}
	
	}
</script>

<style scoped>
	.agency-xls-upload h1{
		font-size: 36px;
		font-weight: bold;
		text-align: center;
		margin-top: 2px;
		margin-bottom: 50px;
	}
	.row{
		margin-top: 30px;padding-top: 10px; border-top: 1px solid #ccc;
	}

	
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.agency-xls-upload h1{
			font-size: 28px;
		}
	
	}
</style>